import styled from "styled-components";

export const TextField = styled.input`
  border: none;
  text-align: right;
  width: 100%;
`;
